export const DEFAULT_INPUT_EXCLUDE_SYMBOLS = '[;:<>"\'+!{}\\[\\]\\^]|(\u00A9|\u00AE|[\u2000-\u3300]|\uD83C[\uD000-\uDFFF]|\uD83D[\uD000-\uDFFF]|\uD83E[\uD000-\uDFFF])'
export const FormFields = Object.freeze({
  gb: {
    code: 'en',
    fields: [
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'building',
        label: 'building',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true,
          maxLength: 95
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'floor',
        label: 'floor',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: true,
        validations: {
          required: false,
          regex: /^$|^[^<>?.;'_=+`~!@#$%^&*[\]/±§]+$/,
          maxLength: 25
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'region',
        label: 'region',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  dk: {
    code: 'dk',
    fields: [{
      model: 'building',
      label: 'building',
      type: 'text',
      show: false,
      validations: {
        required: false
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }, {
      model: 'floor',
      label: 'floor',
      type: 'text',
      show: false,
      validations: {
        required: false
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }, {
      model: 'street',
      label: 'street',
      type: 'text',
      show: true,
      validations: {
        required: true,
        maxLength: 95
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }, {
      model: 'houseNumber',
      label: 'houseNumber',
      type: 'text',
      show: true,
      class: 'flex-1 mr-5',
      validations: {
        required: true
      }
    }, {
      model: 'annex',
      label: 'annex',
      type: 'text',
      show: true,
      class: 'flex-1',
      validations: {
        required: false,
        regex: /^$|^[^<>?.;'_=+`~!@#$%^&*[\]/±§]+$/,
        maxLength: 25
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }, {
      model: 'postalCode',
      label: 'postalCode',
      type: 'text',
      show: true,
      validations: {
        required: true,
        regex: /^(?:[1-24-9]\d{3}|3[0-8]\d{2})$/i
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }, {
      model: 'city',
      label: 'city',
      type: 'text',
      show: true,
      validations: {
        required: true
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }, {
      model: 'region',
      label: 'region',
      type: 'text',
      show: false,
      validations: {
        required: false
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }]
  },
  nl: {
    code: 'nl',
    fields: [
      {
        model: 'building',
        label: 'building',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'floor',
        label: 'floor',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true,
          maxLength: 30,
          minLength: 2
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        class: 'flex-1 mr-5',
        validations: {
          required: true
        }
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: true,
        class: 'flex-1',
        validations: {
          required: false,
          regex: /^$|^[^<>?.;'_=+`~!@#$%^&*[\]/±§]+$/,
          maxLength: 25
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true,
          regex: /^[1-9][0-9]{3}[\s]{0,1}[A-Za-z]{2}$/i
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'region',
        label: 'region',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  be: {
    code: 'be',
    fields: [{
      model: 'building',
      label: 'building',
      type: 'text',
      show: true,
      validations: {
        required: false
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }, {
      model: 'floor',
      label: 'floor',
      type: 'text',
      show: true,
      validations: {
        required: false
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }, {
      model: 'street',
      label: 'street',
      type: 'text',
      show: true,
      validations: {
        required: true,
        maxLength: 30,
        minLength: 2
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }, {
      model: 'houseNumber',
      label: 'houseNumber',
      type: 'text',
      show: true,
      class: 'flex-1 mr-5',
      validations: {
        required: true
      }
    }, {
      model: 'annex',
      label: 'annex',
      type: 'text',
      show: true,
      class: 'flex-1',
      validations: {
        required: false,
        regex: /^$|^[^<>?.;'_=+`~!@#$%^&*[\]/±§]+$/,
        maxLength: 25
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }, {
      model: 'postalCode',
      label: 'postalCode',
      type: 'text',
      show: true,
      validations: {
        required: true,
        regex: /\d{4}/
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }, {
      model: 'city',
      label: 'city',
      type: 'text',
      show: true,
      validations: {
        required: true
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }, {
      model: 'region',
      label: 'region',
      type: 'text',
      show: false,
      validations: {
        required: false
      },
      excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
    }]
  },
  es: {
    code: 'es',
    fields: [
      {
        model: 'streetType',
        label: 'streetType',
        type: 'select',
        show: true,
        validations: {
          required: true
        },
        options: [
          'Agrupación',
          'Alameda',
          'Apartamento',
          'Avenida',
          'Barranco',
          'Bajada',
          'Bloque',
          'Barrio',
          'barriada',
          'Bulevar',
          'Chalet',
          'Calleja',
          'callejón',
          'Calle',
          'Camino',
          'Colonia',
          'Carretera',
          'Caserío',
          'casas',
          'Cuesta',
          'Diseminado',
          'Edificio',
          'Glorieta',
          'Grupo',
          'Lugar',
          'Mercado',
          'Poblado',
          'Partida',
          'Polígono',
          'Pasaje',
          'Plazoleta',
          'plazuela',
          'Parque',
          'Prolongación',
          'Paseo',
          'Plaza',
          'Rambla',
          'Ronda',
          'Subida',
          'Senda',
          'Travesía',
          'Torrente',
          'Urbanización'
        ]
      },
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true,
          maxLength: 30
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'building',
        label: 'building',
        type: 'text',
        show: true,
        class: 'flex-1',
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'floor',
        label: 'floor',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        class: 'flex-1 mr-5',
        validations: {
          required: true,
          maxLength: 10
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true,
          regex: /^\d{5}$/i
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'region',
        label: 'region',
        type: 'select',
        show: true,
        validations: {
          required: true
        },
        options: [
          'Albacete',
          'Alicante / Alacant',
          'Almería',
          'Araba / Álava',
          'Asturias',
          'Ávila',
          'Badajoz',
          'Barcelona',
          'Bizkaia',
          'Burgos',
          'Cáceres',
          'Cádiz',
          'Cantabria',
          'Castellón / Castelló',
          'Ceuta',
          'Ciudad Real',
          'La Coruña',
          'Córdoba',
          'Cuenca',
          'Gipuzkoa',
          'Girona',
          'Granada',
          'Guadalajara',
          'Huelva',
          'Huesca',
          'Islas Baleares',
          'Jaén',
          'La Rioja',
          'León',
          'Lleida',
          'Lugo',
          'Madrid',
          'Málaga',
          'Melilla',
          'Murcia',
          'Navarra',
          'Ourense',
          'Palencia',
          'Pontevedra',
          'Salamanca',
          'Segovia',
          'Sevilla',
          'Soria',
          'Tarragona',
          'Teruel',
          'Toledo',
          'Valencia / València',
          'Valladolid',
          'Zamora',
          'Zaragoza'
        ]
      }
    ]
  },
  fr: {
    code: 'fr',
    fields: [
      {
        model: 'floor',
        label: 'floor',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        validations: {
          regex: /^$|^[^<>?.;'_=+`~!@#$%^&*[\]/±§]+$/,
          maxLength: 5,
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: true,
        validations: {
          required: false,
          regex: /^$|^[^<>?.;'_=+`~!@#$%^&*[\]/±§]+$/,
          maxLength: 25
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true,
          regex: /^\d{5}$/i
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'region',
        label: 'region',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  at: {
    code: 'at',
    fields: [
      {
        model: 'building',
        label: 'building',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'floor',
        label: 'floor',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        class: 'flex-1 mr-5',
        show: true,
        validations: {
          regex: /^$|^[^<>?.;'_=+`~!@#$%^&*[\]/±§]+$/,
          required: true,
          maxLength: 5
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: true,
        class: 'flex-1',
        validations: {
          required: false,
          regex: /^$|^[^<>?.;'_=+`~!@#$%^&*[\]±§]+$/,
          maxLength: 25
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true,
          regex: /^(?:(?:[1-9])(?:\d{3}))$/i
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'region',
        label: 'region',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  de: {
    code: 'de',
    fields: [
      {
        model: 'building',
        label: 'building',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'floor',
        label: 'floor',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true,
          maxLength: 30
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        validations: {
          required: true,
          maxLength: 5
        }
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: true,
        validations: {
          required: false,
          regex: /^$|^[^<>?.;'_=+`~!@#$%^&*[\]/±§]+$/,
          maxLength: 25
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true,
          regex: /^\d{5}$/i
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'region',
        label: 'region',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  se: {
    code: 'se',
    fields: [
      {
        model: 'building',
        label: 'building',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'floor',
        label: 'floor',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true,
          maxLength: 30
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        validations: {
          required: true,
          numeric: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: false,
        validations: {
          required: false,
          regex: /^$|^[^<>?.;'_=+`~!@#$%^&*[\]/±§]+$/,
          maxLength: 25
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true,
          regex: /^\d{3}\s?\d{2}$/i
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'region',
        label: 'region',
        type: 'text',
        show: false,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  it: {
    code: 'it',
    fields: [
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        validations: {
          required: true,
          numeric: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true,
          regex: /\d{5}/i
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'region',
        label: 'region',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  pl: {
    code: 'pl',
    fields: [
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        validations: {
          required: true,
          numeric: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'region',
        label: 'region',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  ch: {
    code: 'ch',
    fields: [
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        class: 'flex-1 mr-5',
        validations: {
          required: false
        }
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: true,
        class: 'flex-1',
        validations: {
          required: false,
          regex: /^$|^[^<>?.;'_=+`~!@#$%^&*[\]/±§]+$/,
          maxLength: 25
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  ie: {
    code: 'ie',
    fields: [
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        class: 'flex-1 mr-5',
        validations: {
          required: false
        }
      },
      {
        model: 'building',
        label: 'building',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'region',
        label: 'region',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'Eircode',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  lu: {
    code: 'lu',
    fields: [
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        class: 'flex-1 mr-5',
        validations: {
          required: false
        }
      },
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  fi: {
    code: 'fi',
    fields: [
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        class: 'flex-1 mr-5',
        validations: {
          required: false
        }
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: true,
        class: 'flex-1',
        validations: {
          required: false,
          maxLength: 25
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  pt: {
    code: 'pt',
    fields: [
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        class: 'flex-1 mr-5',
        validations: {
          required: false
        }
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: true,
        class: 'flex-1',
        validations: {
          required: false,
          maxLength: 25
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'region',
        label: 'region',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  no: {
    code: 'no',
    fields: [
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        class: 'flex-1 mr-5',
        validations: {
          required: true
        }
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: true,
        class: 'flex-1',
        validations: {
          required: false,
          maxLength: 25
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  },
  cz: {
    code: 'cz',
    fields: [
      {
        model: 'street',
        label: 'street',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'houseNumber',
        label: 'houseNumber',
        type: 'text',
        show: true,
        class: 'flex-1 mr-5',
        validations: {
          required: true
        }
      },
      {
        model: 'annex',
        label: 'annex',
        type: 'text',
        show: true,
        class: 'flex-1',
        validations: {
          required: false,
          maxLength: 25
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'postalCode',
        label: 'postalCode',
        type: 'text',
        show: true,
        validations: {
          required: true
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      },
      {
        model: 'city',
        label: 'city',
        type: 'text',
        show: true,
        validations: {
          required: false
        },
        excludeSymbols: DEFAULT_INPUT_EXCLUDE_SYMBOLS
      }
    ]
  }
})

export const Locales = Object.freeze({
  nl: 'nl',
  en: 'en',
  de: 'de',
  fr: 'fr',
  es: 'es',
  sv: 'sv',
  da: 'da',
  it: 'it',
  pl: 'pl',
  pt: 'pt',
  fi: 'fi',
  no: 'no',
  cs: 'cs'
})

export const LocaleNames = Object.freeze({
  nl: 'Nederlands',
  en: 'English',
  de: 'Deutsch',
  da: 'Dansk',
  fr: 'Français',
  es: 'Español',
  sv: 'Svenska',
  it: 'Italiano',
  pl: 'Polskie',
  pt: 'Português',
  fi: 'Suomi',
  no: 'Norsk',
  cs: 'České'
})

export const LocaleIcons = Object.freeze({
  nl: 'nl',
  en: 'en',
  de: 'de',
  da: 'da',
  fr: 'fr',
  es: 'es',
  sv: 'se',
  it: 'it',
  pl: 'pl',
  pt: 'pt',
  fi: 'fi',
  no: 'no',
  cs: 'cs'
})

export const CountryNames = Object.freeze({
  at: 'Countries.at',
  be: 'Countries.be',
  de: 'Countries.de',
  dk: 'Countries.dk',
  es: 'Countries.es',
  fr: 'Countries.fr',
  nl: 'Countries.nl',
  gb: 'Countries.gb',
  se: 'Countries.se',
  it: 'Countries.it',
  pl: 'Countries.pl',
  ch: 'Countries.ch',
  ie: 'Countries.ie',
  lu: 'Countries.lu',
  pt: 'Countries.pt',
  fi: 'Countries.fi',
  no: 'Countries.no',
  cz: 'Countries.cz'
})

export const CountrySelectOptions = Object.freeze(Object.entries(CountryNames).map(([key, value]) => ({
  svg: key,
  label: value,
  value: key
})))

export const CountryCodes = Object.freeze({
  austria: 'at',
  belgium: 'be',
  denmark: 'dk',
  germany: 'de',
  spain: 'es',
  france: 'fr',
  netherlands: 'nl',
  unitedKingdom: 'gb',
  sweden: 'se',
  italy: 'it',
  poland: 'pl',
  switzerland: 'ch',
  ireland: 'ie',
  luxembourg: 'lu',
  portugal: 'pt',
  finland: 'fi',
  norway: 'no',
  czechRepublic: 'cz'
})

export const NewCountries = []

export const WomenCountries = [CountryCodes.netherlands, CountryCodes.belgium, CountryCodes.france, CountryCodes.germany, CountryCodes.austria, CountryCodes.unitedKingdom, CountryCodes.denmark, CountryCodes.finland, CountryCodes.sweden, CountryCodes.norway, CountryCodes.czechRepublic, CountryCodes.switzerland]

export const CountrySelectOptionsLimited = Object.freeze(Object.entries(CountryNames).filter(([key]) => WomenCountries.includes(key)).map(([key, value]) => ({
  svg: key,
  label: value,
  value: key
})))

export const Currencies = Object.freeze({
  [CountryCodes.austria]: 'EUR',
  [CountryCodes.belgium]: 'EUR',
  [CountryCodes.denmark]: 'DKK',
  [CountryCodes.germany]: 'EUR',
  [CountryCodes.spain]: 'EUR',
  [CountryCodes.france]: 'EUR',
  [CountryCodes.netherlands]: 'EUR',
  [CountryCodes.unitedKingdom]: 'GBP',
  [CountryCodes.sweden]: 'SEK',
  [CountryCodes.italy]: 'EUR',
  [CountryCodes.poland]: 'PLN',
  [CountryCodes.switzerland]: 'CHF',
  [CountryCodes.ireland]: 'EUR',
  [CountryCodes.luxembourg]: 'EUR',
  [CountryCodes.portugal]: 'EUR',
  [CountryCodes.finland]: 'EUR',
  [CountryCodes.norway]: 'NOK',
  [CountryCodes.czechRepublic]: 'CZK'
})

export const CountryIds = Object.freeze({
  nl: 1,
  be: 2,
  de: 3,
  at: 4,
  gb: 5,
  es: 6,
  fr: 7,
  se: 8,
  dk: 9,
  it: 10,
  pl: 11,
  ch: 12,
  lu: 13,
  ie: 14,
  pt: 15,
  fi: 16,
  no: 17,
  cz: 18
})

export const CountryByIds = Object.freeze({
  1: 'nl',
  2: 'be',
  3: 'de',
  4: 'at',
  5: 'gb',
  6: 'es',
  7: 'fr',
  8: 'se',
  9: 'dk',
  10: 'it',
  11: 'pl',
  12: 'ch',
  13: 'lu',
  14: 'ie',
  15: 'pt',
  16: 'fi',
  17: 'no',
  18: 'cz'
})

export const CountryIso3 = Object.freeze({
  nl: 'NLD',
  be: 'BEL',
  de: 'DEU',
  at: 'AUT',
  gb: 'GBR',
  fr: 'FRA',
  es: 'ESP',
  se: 'SWE',
  dk: 'DNK',
  it: 'ITA',
  pl: 'POL',
  ch: 'CHE',
  ie: 'IRL',
  lu: 'LUX',
  pt: 'PRT',
  fi: 'FIN',
  no: 'NOR',
  cz: 'CZE'
})

export const ProductGroupIds = Object.freeze({
  originals: 1,
  one: 2,
  boys: 3
})

export const LocaleIsoCodes = Object.freeze({
  de: 'de_DE',
  da: 'da_DK',
  es: 'es_ES',
  fr: 'fr_FR',
  nl: 'nl_NL',
  en: 'en_GB',
  sv: 'sv_SE',
  it: 'it_IT',
  pl: 'pl_PL',
  pt: 'pt_PT',
  fi: 'fi_FI',
  no: 'no_NO',
  cs: 'cs_CZ'
})

export const LanguageCountryCodes = Object.freeze({
  de: 'de_DE',
  at: 'de_AT',
  da: 'da_DK',
  es: 'es_ES',
  fr: 'fr_FR',
  nl: 'nl_NL',
  be: 'nl_BE',
  en: 'en_GB',
  sv: 'sv_SE',
  it: 'it_IT',
  pl: 'pl_PL',
  ch: 'DE_CH',
  ie: 'en_IE',
  lu: 'fr_LU',
  pt: 'pt_PT',
  fi: 'fi_FI',
  no: 'no_NO',
  cs: 'cs_CZ'
})

export const CountryCodesByLocale = Object.freeze({
  at: 'AT',
  be: 'BE',
  de: 'DE',
  da: 'DK',
  es: 'ES',
  fr: 'FR',
  nl: 'NL',
  en: 'GB',
  se: 'SE',
  it: 'IT',
  pl: 'PL',
  pt: 'PT',
  fi: 'FI',
  no: 'NO',
  cs: 'CZ'
})

export const ScreenBreakpoints = Object.freeze({
  lg: 1024,
  md: 768,
  container: 640,
  sm: 520,
  xsplus: 400,
  xs: 320
})

export const PaymentStatusses = Object.freeze({
  success: 'success',
  failed: 'failed',
  pending: 'pending'
})

export const QueryParams = Object.freeze({
  product: 'product',
  orientation: 'orientation',
  orientations: 'orientations',
  memberId: 'memberId',
  orderBundleId: 'orderBundleId'
})

export const TestPeriodDays = Object.freeze({
  [CountryCodes.austria]: 14,
  [CountryCodes.belgium]: 10,
  [CountryCodes.denmark]: 14,
  [CountryCodes.germany]: 14,
  [CountryCodes.spain]: 14,
  [CountryCodes.france]: 14,
  [CountryCodes.netherlands]: 10,
  [CountryCodes.unitedKingdom]: 14,
  [CountryCodes.sweden]: 14,
  [CountryCodes.italy]: 14,
  [CountryCodes.poland]: 14,
  [CountryCodes.switzerland]: 14,
  [CountryCodes.ireland]: 14,
  [CountryCodes.luxembourg]: 14,
  [CountryCodes.portugal]: 14,
  [CountryCodes.finland]: 14,
  [CountryCodes.norway]: 14,
  [CountryCodes.czechRepublic]: 14
})

export const DaysToSubtractFromDeliveryDate = 3
